import { memo, type ReactNode } from "react";
import Modal from "../../../../common/components/Modal";
import { IMG_OPTIME_PARTS } from "../../../../utils/url/staticResources";
import { useTranslation } from "react-i18next";
import { Alert } from "~/common/mui/Alert/Alert";
import { Stack, styled } from "~/common/mui";

interface Props {
  onClose: () => void;
  closeButton: ReactNode;
  continueButton: ReactNode;
}

const OptimeInfoPopup = (props: Props) => {
  const { onClose, closeButton, continueButton } = props;
  const { t } = useTranslation();
  return (
    <Modal
      onClose={onClose}
      title={t("optimePopup.completeOptime")}
      footerChildren={
        <Stack direction={"row"} gap={1}>
          {closeButton}
          {continueButton}
        </Stack>
      }
    >
      <Alert severity="info">{t("cartPage.optimePopup.info.text")}</Alert>
      <OptimeImageContainer>
        <img className={"w-100"} src={IMG_OPTIME_PARTS} />
      </OptimeImageContainer>
      <OptimeProductNames>
        <OptimeProductName>{t("optimePopup.product.sensor")}</OptimeProductName>
        <OptimeProductName>{t("optimePopup.product.gateway")}</OptimeProductName>
        <OptimeProductName>{t("optimePopup.product.dst")}</OptimeProductName>
      </OptimeProductNames>
    </Modal>
  );
};

export default memo(OptimeInfoPopup);

const OptimeImageContainer = styled("div")({
  width: "100%",
});

const OptimeProductNames = styled("div")(({ theme }) => ({
  display: "flex",
  marginBottom: theme.spacing(3.75),
}));

const OptimeProductName = styled("div")(({ theme }) => ({
  width: "33.3%",
  paddingLeft: theme.spacing(2.5),
  position: "relative",
  bottom: 60,
}));
